export type ProjectBudgetType = "fixed_fee" | "fee_cap" | "hours_cap";
export type TaskPriority = "low" | "medium" | "high" | "urgent";

export const PROJECT_BUDGET_OPTIONS: Array<{
  label: string;
  value: ProjectBudgetType;
}> = [
  { label: "Fixed fee", value: "fixed_fee" },
  { label: "Fee cap", value: "fee_cap" },
  { label: "Hours cap", value: "hours_cap" },
];

export const TASK_PRIORITY_OPTIONS: Array<{
  label: string;
  value: TaskPriority;
}> = [
  { label: "Low", value: "low" },
  { label: "Medium", value: "medium" },
  { label: "High", value: "high" },
  { label: "Urgent", value: "urgent" },
];

export function projectBudgetTypeLabel(value: string) {
  return (
    PROJECT_BUDGET_OPTIONS.find((option) => option.value === value)?.label ??
    "Fixed fee"
  );
}

export function taskPriorityLabel(value: string) {
  return (
    TASK_PRIORITY_OPTIONS.find((option) => option.value === value)?.label ??
    "Medium"
  );
}
